export default "__VITE_ASSET__B3MS48Zv__"